import React, {useState} from 'react'
import './navbar.css'
import { vehicleData, callData } from './nav-data';
import NavDropDown from './Nav-drop-down';
import LocationDrop from './Location-drop';
import HoursDrop from './Hours-drop';
import CoalitionDrop from './Coalition-drop';
import {motion} from 'framer-motion'
const listItemVariant = {
    hover: {
        scale: 1.1,
        transition: {
            delay: .3,
            duration: .3
        }
    }
}
export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false)
    const openSidebar = () => {
        const sideBar = document.querySelector('.nav-items ul');
        sideBar.classList.toggle('open')
        setIsOpen((prev) => !prev)
    }
  return (
    <div className='navbar-container'>
        <div className="logo">
            <img src="assets/red-toyota-logo-removebg-preview.png" alt="" />
            <img src="assets/Don-McGill-Toyota-Logo-Main.avif" alt="" />
        </div>
        <div className="nav-items">
            <ul>
                <motion.li
                    variants={listItemVariant}
                    whileHover="hover">
                    <p>Vehicles</p>
                    <NavDropDown array={vehicleData}  />
                </motion.li>
                <motion.li
                    variants={listItemVariant}
                    whileHover="hover">
                    <p>Call</p>
                    <NavDropDown array={callData}  />
                </motion.li>
                <motion.li
                    variants={listItemVariant}
                    whileHover="hover">
                    <p>Location</p>
                    <LocationDrop  />
                </motion.li>
                <motion.li
                    variants={listItemVariant}
                    whileHover="hover">
                    <p>Hours</p>
                    <HoursDrop  />
                </motion.li>
                <motion.li
                    variants={listItemVariant}
                    whileHover="hover">
                    <p>Collision</p>
                    <CoalitionDrop  />
                </motion.li>
            </ul>
        </div>
        <div className="phone-number">
            <i className='bx bxs-phone-call'></i>
            <p>844.529.1532</p>
            {
                isOpen
                ? <i className='bx bx-x' onClick={openSidebar}></i>
                : <i className='bx bx-menu' onClick={openSidebar}></i>
            }
            
        </div>
    </div>
  )
}
